import { Box, Grid, Typography } from "@mui/material";
import React from "react";

import TransmissionGrid from "./TransmissionGrid";
import { useState } from "react";
import { useContext } from "react";
import { AuthContext } from "../AuthContext";
import {
  getTransmissionDetailsByDealer,
  getTransmissionDetailsHistoryByDealer,
} from "../services/dealerServices";
import { useEffect } from "react";
import TransmissionDetails from "./TransmissionDetails";
import { DealerSearch } from "./DealerSearch";

const TransmissionDetailsList = () => {
  //console.log("loading transmission details for :", displayType);
  const { group, APP_ENV ,dealer} = useContext(AuthContext);
  const [transmissionDetailsListData, setTransmissionDetailsListData] =
    useState([]);
  const [logdata, setLogdata] = useState(null);
  const [disType, setDisType] = useState("admin");
  const [selectedDealer, setSelectedDealer] = useState();
  const [showDealer,setShowDealer] = useState(false);
  const [loading,setLoading]=useState(false);
  // useEffect(() => {
  //   setDisType(displayType);
  //   setSelectedDealer(dealer);
  // }, [displayType, dealer]);

  useEffect(()=>{
    if(group === "jbw-admin"){
      setDisType('admin')
      setShowDealer(true);
    }else{
      setDisType('dealers')
      setShowDealer(false);
      setSelectedDealer(dealer);
    }
  },[group])

  const getTransmissionListData = (dealerId) => {
    //   console.log("dealer id :", dealerId);
    getTransmissionDetailsByDealer(dealerId)
      .then(
        (res) => {
          console.log("transmission res :", res);
          const data = APP_ENV === "Development" ? res.data.body : res.data;
          console.log("transmission data :", data);
          const statusCode = res.status;
          if (statusCode === 200 && data.length > 0) {
            setTransmissionDetailsListData(data);
            setLogdata(data[0]);
          }
        },
        (err) => {
          console.log("Unable retrive Transmission List data", err);
        }
      )
      .catch((err) => {
        console.error("Transmission List service Error :", err);
      });
  };

  const getTransmissionHistoryListData = (dealerId) => {
    //  console.log("dealer id :", dealerId);
    setLoading(true);
    getTransmissionDetailsHistoryByDealer(dealerId)
      .then(
        (res) => {
          const data = APP_ENV === "Development" ? res.data.body : res.data;
          console.log("transmission History data :", data);
          const statusCode = res.status;
          if (statusCode === 200 && data.length > 0) {
            setTransmissionDetailsListData(data);
            setLogdata(data[0]);
            setLoading(false);
          }else{
            setLoading(false);
          }
        },
        (err) => {
          console.log("Unable retrive Transmission List data", err);
        }
      )
      .catch((err) => {
        console.error("Transmission List service Error :", err);
      });
  };

  const loadData = () =>{
    setTransmissionDetailsListData([]);
    setLogdata(null);
    const dealerId = selectedDealer ? selectedDealer.dealerId : 0;
    console.log("loading data for dealer id :",selectedDealer?.dealerId);
    // if (disType === "admin") {
    //   getTransmissionListData(0);
    // } else {
    if(selectedDealer && selectedDealer.dealerId>0){
      getTransmissionHistoryListData(dealerId);
    }
    // }
  }

  useEffect(() => {
loadData();
  }, [selectedDealer?.dealerId]);

  const handlelogclicked = (param) => {
    console.log("selected Row Log :", param);
    setLogdata(param);
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={6} sm={8} lg={8}>
        <Box
          sx={{
            maxWidth: "100%",
            padding: 2,
            boxShadow: 4,
            borderRadius: 3,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            backgroundColor: "#fff",
          }}
        >
          <Grid container>
            <Grid item xs={12} sm={12} lg={12}>
              <Box
                sx={{
                  maxWidth: "100%",
                  padding: 1,
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Typography variant="h6" component="h6">
                  Transmission Details <br />
                </Typography>
                {group === "jbw-admin" && (
                  <Box sx={{ position: "relative", marginLeft: 5 }}>
                    <DealerSearch
                    type="syncSearch"
                      onSelect={(value) => {
                        console.log("Auto complete delaer value :", value);
                        if (!value) return;
                        setSelectedDealer(value);
                      }}
                    />
                  </Box>
                )}
                <Box sx={{ flexGrow: 1 }} />
              </Box>
              <Box
                sx={{
                  maxWidth: "100%",
                  padding: 1,
                  display: "flex",
                  flexDirection: "row",
                  maxHeight: "50vh",
                }}
              >
                <TransmissionGrid
                  transmissionListData={transmissionDetailsListData}
                  showDealer={false}
                  onlogclicked={handlelogclicked}
                  loading={loading}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid item xs={6} sm={4} lg={4}>
        <TransmissionDetails logdata={logdata} />
      </Grid>
    </Grid>
  );
};

export default TransmissionDetailsList;
